export default "__VITE_ASSET__f0f400b2__"